"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var ErrorOutline_1 = __importDefault(require("@mui/icons-material/ErrorOutline"));
var Warning_1 = __importDefault(require("@mui/icons-material/Warning"));
var react_i18next_1 = require("react-i18next");
var macos_svg_1 = __importDefault(require("./img/macos.svg"));
var ios_svg_1 = __importDefault(require("./img/ios.svg"));
var macosEmpty_svg_1 = __importDefault(require("./img/macosEmpty.svg"));
var iosEmpty_svg_1 = __importDefault(require("./img/iosEmpty.svg"));
var identity_svg_1 = __importDefault(require("./img/identity.svg"));
var federation_svg_1 = __importDefault(require("./img/federation.svg"));
var identityCheck_svg_1 = __importDefault(require("./img/identityCheck.svg"));
var federationCheck_svg_1 = __importDefault(require("./img/federationCheck.svg"));
var identityNotConfigured_svg_1 = __importDefault(require("./img/identityNotConfigured.svg"));
var federationNotConfigured_svg_1 = __importDefault(require("./img/federationNotConfigured.svg"));
var orphan_svg_1 = __importDefault(require("./img/orphan.svg"));
var pxToRem = function (px) {
    return "".concat(px / 16, "rem");
};
function AppInstanceTitle(_a) {
    var logo = _a.logo, name = _a.name, onClick = _a.onClick, selectable = _a.selectable, checked = _a.checked, variant = _a.variant, big = _a.big, warnings = _a.warnings, locked = _a.locked, subTitle = _a.subTitle, reverse = _a.reverse, identity = _a.identity, desktop = _a.desktop, mobile = _a.mobile, dashed = _a.dashed, light = _a.light;
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ "data-testid": "appTile", onClick: onClick, sx: {
            width: big ? pxToRem(170) : pxToRem(128),
            height: big ? pxToRem(170) : pxToRem(128),
            boxShadow: '0px 2px 12px #00000014',
            borderRadius: '20px',
            display: 'flex',
            borderColor: dashed ? '#62AC6A' : 'transparent',
            borderStyle: 'dashed',
            borderWidth: dashed ? '2px' : '0px',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: '33px',
            paddingBottom: '17px',
            backgroundColor: checked
                ? "".concat(reverse ? '#FFFFFF' : 'secondary.light')
                : "".concat(reverse ? 'secondary.light' : '#FFFFFF'),
            color: checked
                ? "".concat(reverse ? 'transparent' : '#9DA8B3')
                : "".concat(reverse ? '#9DA8B3' : 'transparent'),
            cursor: !locked && onClick !== undefined ? 'pointer' : 'default',
            '&:hover': {
                color: selectable || checked
                    ? "".concat(reverse ? 'transparent' : '#62AC6A')
                    : "".concat(reverse ? '#62AC6A' : 'transparent'),
                backgroundColor: !locked && variant === 'default'
                    ? "".concat(reverse ? 'parent' : 'secondary.light')
                    : "".concat(reverse ? 'secondary.light' : 'parent'),
            },
            position: 'relative',
        } }, { children: [big && !light && ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", justifyContent: "center", spacing: 1, sx: {
                    position: 'absolute',
                    left: "10px",
                    top: '45px',
                } }, { children: [(identity === null || identity === void 0 ? void 0 : identity.find(function (ident) {
                        return ident.kind === 'IDENTITY_MANAGEMENT' &&
                            ident.status === 'CONFIGURED_RUNNING';
                    })) && ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: t('ds.tiles.identity.configured'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '20px',
                                width: '20px',
                            }, src: identityCheck_svg_1.default }) }))), (identity === null || identity === void 0 ? void 0 : identity.find(function (ident) {
                        return ident.kind === 'IDENTITY_MANAGEMENT' &&
                            (ident.status === 'NOT_CONFIGURED' ||
                                ident.status === null ||
                                ident.status === undefined);
                    })) && ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: t('ds.tiles.identity.notconfigured'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '20px',
                                width: '20px',
                            }, src: identityNotConfigured_svg_1.default }) }))), (identity === null || identity === void 0 ? void 0 : identity.find(function (ident) { return ident.kind === 'IDENTITY_MANAGEMENT'; })) === undefined && ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: t('ds.tiles.identity.notavailable'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '20px',
                                width: '20px',
                            }, src: identity_svg_1.default }) }))), (identity === null || identity === void 0 ? void 0 : identity.find(function (ident) {
                        return ident.kind === 'FEDERATION' &&
                            ident.status === 'CONFIGURED_RUNNING';
                    })) && ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: t('ds.tiles.federation.configured'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '20px',
                                width: '20px',
                            }, src: federationCheck_svg_1.default }) }))), (identity === null || identity === void 0 ? void 0 : identity.find(function (ident) {
                        return ident.kind === 'FEDERATION' &&
                            (ident.status === 'NOT_CONFIGURED' ||
                                ident.status === null ||
                                ident.status === undefined);
                    })) && ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: t('ds.tiles.federation.notconfigured'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '20px',
                                width: '20px',
                            }, src: federationNotConfigured_svg_1.default }) }))), (identity === null || identity === void 0 ? void 0 : identity.find(function (ident) { return ident.kind === 'FEDERATION'; })) === undefined && ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: t('ds.tiles.federation.notavailable'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '20px',
                                width: '20px',
                            }, src: federation_svg_1.default }) })))] }))), big && !light && ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", justifyContent: "center", alignItems: "center", sx: {
                    position: 'absolute',
                    right: "5px",
                    top: '43px',
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: (mobile === null || mobile === void 0 ? void 0 : mobile.find(function (mob) { return mob.kind === 'IOS'; }))
                            ? t('ds.tiles.ios.available')
                            : t('ds.tiles.ios.notavailable'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '25px',
                                width: '25px',
                            }, src: (mobile === null || mobile === void 0 ? void 0 : mobile.find(function (mob) { return mob.kind === 'IOS'; }))
                                ? ios_svg_1.default
                                : iosEmpty_svg_1.default }) })), (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: (desktop === null || desktop === void 0 ? void 0 : desktop.find(function (desk) { return desk.kind === 'MAC_OS'; }))
                            ? t('ds.tiles.macos.available')
                            : t('ds.tiles.macos.notavailable'), placement: "right-end", arrow: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", sx: {
                                height: '30px',
                                width: '30px',
                            }, src: (desktop === null || desktop === void 0 ? void 0 : desktop.find(function (desk) { return desk.kind === 'MAC_OS'; }))
                                ? macos_svg_1.default
                                : macosEmpty_svg_1.default }) }))] }))), warnings &&
                (warnings.includes('USER_SYNC') || warnings.includes('GROUP_SYNC')) ? ((0, jsx_runtime_1.jsx)(Warning_1.default, { sx: {
                    position: 'absolute',
                    top: '5px',
                    left: '5px',
                    color: 'redWarning.main',
                } })) : ((0, jsx_runtime_1.jsx)(ErrorOutline_1.default, { sx: {
                    position: 'absolute',
                    top: '5px',
                    left: '5px',
                    color: 'rgba(237, 108, 2, 0.7)',
                    display: (warnings === null || warnings === void 0 ? void 0 : warnings.includes('NO_GROUP_LINKED')) ||
                        (warnings === null || warnings === void 0 ? void 0 : warnings.includes('ORPHANED_APPLICATION_INSTANCE'))
                        ? 'inherit'
                        : 'none',
                } })), (0, jsx_runtime_1.jsx)(material_1.Box, { component: "img", src: logo !== null && logo !== undefined
                    ? logo.replace('$SERVER_BASE_URL', process.env.API_PATH || '')
                    : orphan_svg_1.default, sx: {
                    width: big ? pxToRem(66) : pxToRem(51),
                    height: big ? pxToRem(66) : pxToRem(51),
                } }), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", sx: {
                    alignItems: 'center',
                } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body1", color: "#4B4D4C", sx: {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            textAlign: 'center',
                            width: big ? pxToRem(150) : pxToRem(108),
                        } }, { children: name })), subTitle && ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption", color: "text.hint" }, { children: subTitle })))] }))] })));
}
exports.default = AppInstanceTitle;
AppInstanceTitle.defaultProps = {
    onClick: undefined,
    selectable: false,
    checked: false,
    variant: 'default',
    big: false,
    warnings: [],
    locked: false,
    subTitle: undefined,
    reverse: false,
    identity: [],
    desktop: [],
    mobile: [],
    dashed: false,
    light: false,
};
//# sourceMappingURL=Tile.js.map